import { Pagination } from '$core/models/pagination';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

export interface PaginationParams {
  perPage?: number;
  page?: number;
}

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnChanges {
  @Input() public items: Pagination;
  @Input() public fixedSize = false;
  @Input() public pageSizeItemKey = '';
  @Input() public isBottomOrientation = false;
  @Input() public allowedPageSizes = [5, 15, 25, 50];
  @Input() public localStorageKey = '';
  @Output() public pageChange = new EventEmitter<PaginationParams>();
  public savedItemsPerPage: string;
  public params: PaginationParams = { page: 1 };

  public ngOnChanges() {
    if (this.localStorageKey) {
      localStorage.setItem(this.localStorageKey, String(this.items.per_page));
      this.savedItemsPerPage =
        localStorage.getItem(this.localStorageKey) || '5';
    }
  }

  public pageChanged(paginationEvent: PageChangedEvent): void {
    if (
      paginationEvent.itemsPerPage === this.items.per_page &&
      paginationEvent.page === this.items.current_page
    ) {
      return;
    }

    this.params = {
      perPage: paginationEvent.itemsPerPage,
      page: paginationEvent.page,
    };

    if (paginationEvent.itemsPerPage !== Number(this.savedItemsPerPage)) {
      this.savedItemsPerPage = String(paginationEvent.itemsPerPage);
      localStorage.setItem(this.localStorageKey, this.savedItemsPerPage);
    }

    this.pageChange.emit(this.params);
  }

  public allowedPageSizesChange(allowedPageParams: PaginationParams) {
    this.pageChanged({
      itemsPerPage: allowedPageParams.perPage,
      page: this.params.page,
    });
  }
}
